import React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { PROVIDER_CONFIRM } from '../../constants/routing';
import withStyles from '@material-ui/core/styles/withStyles';

const StyledButton = withStyles({
  root: {
    maxWidth: 300,
    width: '100%',
    margin: 'auto',
  },
})(Button);

type Props = Omit<ButtonProps, 'variant' | 'href'>;

const ProviderConfirmButton = (props: Props) => {
  const { t } = useTranslation();
  return (
    <StyledButton variant="outlined" href={PROVIDER_CONFIRM} {...props}>
      {t('logins.forgotProvider')}
    </StyledButton>
  );
};

export default ProviderConfirmButton;
